import { FunctionComponent, ReactElement } from 'react';
import { IconButton, TableCell } from '../../tailwindcomponents';
import { Check, Edit, Delete, Close } from '../../components/icons';
import { palette } from '../../theme/palette';
type EditColumnProps = {
    index: number,
    editRow: number,
    setEditRow: Function,
    saveChanges: Function,
    deleteRow?: () => void,
    customIcon?: ReactElement,
    abort?: boolean,
}

const EditColumn: FunctionComponent<EditColumnProps> = ({ index, editRow, setEditRow, saveChanges, deleteRow, customIcon, abort }) => {

    // Displays Edit Icon not in edit mode (editRow and index not the same)
    // Displays Save and Delete Icon Buttons when in edit mode
    return (
        <TableCell className="pr-0 w-[120px]">
            {editRow !== index ?
                <IconButton onClick={() => setEditRow(index)} color="default" >
                    {customIcon === undefined ?
                        <Edit />
                        :
                        customIcon
                    }
                </IconButton>
                :
                editRow === index &&
                <div className="flex flex-row flex-wrap">
                    <div>
                        <IconButton onClick={() => saveChanges()} className="p-1.5" style={{ color: palette.success }} >
                            <Check className="text-[28px]" />
                        </IconButton>
                    </div>
                    <div>
                    {deleteRow &&
                        <IconButton onClick={() => deleteRow()} className="p-1.5 pr-0" style={{ color: palette.error }} >
                            <Delete className="text-[28px]" />
                        </IconButton>
                    }
                    </div>
                    {abort === true &&
                        <div>
                            <IconButton onClick={() => setEditRow()} className="p-1.5 pr-0" style={{ color: palette.content }} >
                                <Close className="text-[28px]" />
                            </IconButton>
                        </div>
                    }
                </div>
            }
        </TableCell>
    );
};
export default EditColumn;
